export enum TaskType {
  SYSTEM = 'SYSTEM', // System data update (auto)
  ACTION = 'ACTION', // Click to perform action (fill form/upload)
  MANUAL = 'MANUAL'  // Manual self-check (checkbox)
}

export enum TaskStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  WARNING = 'WARNING' // For alerts/pre-warnings
}

export interface Phase {
  id: string;
  name: string;
  order: number;
}

export interface Category {
  id: string;
  name: string;
}

export interface Task {
  id: string;
  title: string;
  description?: string;
  phaseId: string;
  categoryId: string;
  type: TaskType;
  status: TaskStatus;
  dueDate?: string; // ISO date string
  isCustom?: boolean; // If added by user
  warningMessage?: string; // If status is WARNING
}